import { indexDB } from 'ynf-core-middleware'
import { getTplId } from '../http'
import { isJDiwork, getContext, isObjectEmpty } from '../util'

const ynfMetaCache = 'ynfMetaCache'

const getMetaDbInstance = async () => {
  const dbInstance = await indexDB.init("ynfMetaDB", 1, [
    { tableName: ynfMetaCache, options: { keyPath: "ynfMetaId", autoIncrement: false } },
  ]);
  return dbInstance;
}

// 获取缓存中的meta数据
const getMetaData = async (dbInstance, key) => {
  const res = await dbInstance.query(ynfMetaCache, (item) => item.ynfMetaId === key)
  return res[0]?.metaData || null
}

// 插入meta数据
const insertMetaData = async (ynfMetaId, metaData) => {
  const dbInstance = await getMetaDbInstance()
  await dbInstance.insert(ynfMetaCache, { ynfMetaId, metaData})
}

// 清空meta数据
const clearMetaData = async (dbInstance) => {
  await dbInstance.clearTable(ynfMetaCache)
}

const getYnfMetaId = (params) => {
  const { tenantId, tplId, tplid, billNo } = params
  // 租户id+tplid+billno
  return `${tenantId || getContext().tenantid}_${tplId || tplid}_${billNo}`
}

const isMobileTerminal = (param) => {
  // terminalType是3，代表移动端
  if (param.terminalType === '3') {
    return true
  }
  return false
}
/**
 * 从本地获取缓存，确保缓存的有效性，否则返回 undefined
 * @param {*} param
 * @returns
 */
export const getMetaCache = async (param) => {
  // 移动端不操作缓存
  if (isMobileTerminal(param)) return
  // 支持零代码直接使用page组件预览，增加metaCache=false的参数判断，metaCache=false也不走缓存
  if (param.metaCache === 'false' || param.metaCache === false) return

  let metaCache = undefined
  try {
    const dbInstance = await getMetaDbInstance()
    const params = {...param}
    // pc端工作台大刷就清空cache
    if (isJDiwork() && !window.__YNF_META_CACHE_CLEAR__) {
      window.__YNF_META_CACHE_CLEAR__ = true
      console.log('==============metacache: 清空缓存')
      await clearMetaData(dbInstance)
    }
    // 如果页面param没有tplId参数，就从接口中获取
    if (!params.tplId && !params.tplid) {
      const { tplId } = await getTplId(params.billNo, params)
      params.tplId = tplId
    }
    // 获取key
    const key = getYnfMetaId(params)
    metaCache = await getMetaData(dbInstance, key)
  } catch (error) {
    console.warn('缓存启用失败', error)
  }
  return isObjectEmpty(metaCache) ? undefined : metaCache
}

export const setMetaCache = async (meta, param) => {
  // 移动端不操作缓存
  if (isMobileTerminal(param)) return

  const params = {...param}
  // 如果页面param没有tplId参数，就从meta里获取
  if (!params.tplId && !params.tplid) {
    params.tplId = meta.tplId
  }
  const key = getYnfMetaId(params)
  await insertMetaData(key, meta)
}
